export const CONSUMER_JWT_KEY = "CONSUMER_JWT_TOKEN";
